import { Component, Mixins } from 'vue-property-decorator';
import OrderGridsExcelDown from '@/components/common/order/mixins/OrderGridsExcelDown'

@Component
export default class OrderHoldByReservationGrids extends Mixins(OrderGridsExcelDown) {

  public gridProps: any = {
    options: {
      header: {
        height: 33,
        bacground: '#ccc'
      },
      rowHeaders: ['checkbox'],
      columnOptions: {
        minWidth: 50,
        resizable: true,
      },
      
      displayRowCount: 30,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0,
        centerAlign: true
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    columnOptions: {
      useFormattedValue: true
    },
    showDummyRows: true,
    columns: []
  };

  public listColumns: any = [
    '예약판매시작일',
    '플랫폼구분',
    '쇼핑몰구분',
    '주문구분',
    '회원그룹',
    '추천인',
    '결제수단',
    '주문번호',
    '주문자명',
    '주문자 연락처',
    '회원번호',
    '배송구분',
    '업무메시지',
    '주문상태',
    '파트너사',
    'HS CODE',
    '상품번호',
    '상품관리코드',
    '상품 이미지',
    '상품명',
    '영문상품명',
    '옵션관리코드',
    '옵션명',
    '판매가(할인적용가)',
    '수량',
    '수령자명',
    '수령자휴대전화',
    '배송번호',
    '배송메모',
    '배송방법',
    '주문일시',
    '결제일시',
    '주문상품옵션번호',
    '적립금사용',
    '실결제금액',
  ];
}
